export const getXSRFToken = () => {
	const tokens = JSON.parse(localStorage.getItem('xsrf-tokens') || '{}');

	return tokens[JSON.parse(sessionStorage.getItem('activeAccount'))?.id];
};
